import SvgIcon, { SvgIconProps } from 'LuxKit/SvgIcon'

function LineCameraIcon(props: SvgIconProps) {
  return <SvgIcon {...props} fill="none" viewBox="0 0 24 24">
    <path fill="currentColor" d="M19 6.5h-1.28l-.32-1a3 3 0 0 0-2.84-2H9.44A3 3 0 0 0 6.6 5.55l-.32 1H5a3 3 0 0 0-3 3v8a2.9998 2.9998 0 0 0 3 3h14a2.9997 2.9997 0 0 0 3-3v-8a3.0008 3.0008 0 0 0-1.8403-2.817A3.0002 3.0002 0 0 0 19 6.5Zm1 11a1.0001 1.0001 0 0 1-1 1H5a.9997.9997 0 0 1-1-1v-8a1 1 0 0 1 1-1h2a1 1 0 0 0 1-.68l.54-1.64a1 1 0 0 1 .95-.68h5.12a.9999.9999 0 0 1 .95.68l.54 1.64a1 1 0 0 0 .9.68h2a1 1 0 0 1 1 1v8Zm-8-9a4 4 0 1 0 0 8.0001 4 4 0 0 0 0-8Zm0 6a2.0002 2.0002 0 0 1-1.9616-2.3902 2.0004 2.0004 0 0 1 1.5714-1.5713A1.9997 1.9997 0 0 1 14 12.5a1.9996 1.9996 0 0 1-2 2Z"/>
  </SvgIcon>
}

export default LineCameraIcon
